import { render, staticRenderFns } from "./HubSunset.vue?vue&type=template&id=ffc05c26&scoped=true"
import script from "./HubSunset.vue?vue&type=script&lang=js"
export * from "./HubSunset.vue?vue&type=script&lang=js"
import style0 from "./HubSunset.vue?vue&type=style&index=0&id=ffc05c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc05c26",
  null
  
)

export default component.exports